import React, {Component} from 'react'
import PropTypes from 'prop-types'
// import R from 'ramda'
import {
  Form,
  Grid,
  Message
  // Button
} from 'semantic-ui-react'

// this class uses static class properties for auto-binding
// https://babeljs.io/docs/plugins/transform-class-properties/
// https://github.com/tc39/proposal-private-fields
class LoginForm extends Component {
  state = {
    username: '',
    password: ''
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = () => {
    const { username, password } = this.state;

    const createNavigationObj = (str) => {
      const n = str.split("/").filter(Boolean);
      const ids = n.slice(3);
      return {
        pageName: n[0],
        pageNum: n[1] || 1,
        perPage: n[2] || 20,
        ids: ids.length ? ids : null,
      };
    };

    const navigation = this.props.navigation ? createNavigationObj(this.props.navigation) : null;

    // do we clear the values to protect users that may have left
    // their browser open to an attacker
    this.setState({password: ''})
    this.props.loginAndGoToPage({ username, password, navigation })
  }

  render () {
    const {username, password} = this.state
    return (
      <Grid columns={3}>
        <Grid.Row>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
          </Grid.Column>
          <Grid.Column>
            { this.props.loginError === null ? null
              : <Message negative onDismiss={(e) => this.props.clearAuthError()} header={this.props.loginError} />
            }
            <Form onSubmit={this.handleSubmit}>
              <Form.Input placeholder='Username or email' name='username' value={username || ''} onChange={this.handleChange} />
              <Form.Input placeholder='Password' type='password' name='password' value={password || ''} onChange={this.handleChange} />
              <Form.Button content='Submit' />
            </Form>
          </Grid.Column>
          <Grid.Column>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
        </Grid.Row>
      </Grid>
    )
  }
}

LoginForm.propTypes = {
  loginAndGoToPage: PropTypes.func.isRequired,
  clearAuthError: PropTypes.func.isRequired,
  navigation: PropTypes.string,
  loginError: PropTypes.string
}

export default LoginForm



// WEBPACK FOOTER //
// ./webAdmin/forms/login.js